import { BaseSlide } from '../../../models/slides/BaseSlide';
import { AnimatedCircle } from './AnimatedCircle';

interface NavigationButtonsProps {
  slides: BaseSlide[];
  handleDotClick: (index: number) => void;
  currentIndex: number;
  buttonColor: string;
  autoPlay: boolean;
  isHovered: boolean;
}

/**
 * NavigationButtons component
 * this component is responsible for rendering the navigation buttons of the carousel
 * @param images - the images of the carousel
 * @param handleDotClick - function to handle the dot click
 * @param currentIndex - the current index of the carousel
 * @param buttonColor - the color of the buttons
 * @param autoPlay - the autoplay state of the carousel
 * @param isHovered - the hover state of the carousel
 * @returns NavigationButtons component
 */

export const NavigationButtons = ({ slides, handleDotClick, currentIndex, buttonColor, autoPlay, isHovered }: NavigationButtonsProps) => {
  // Function to show the animation circle if needed
  const showAnimationCircle = (index: number) => {
    // If the index is not the current index, return false
    if (index !== currentIndex) return false;

    // If autoPlay is disabled, return false
    if (!autoPlay) return false;

    // If the carousel is hovered, return false
    if (isHovered) return false;

    return true;
  };

  return (
    <div className='flex items-center gap-1'>
      {slides?.map((_, index) => (
        <div className='flex items-center justify-center relative w-6 h-6'>
          {showAnimationCircle(index) && <AnimatedCircle radius={12} steps={100} duration={4200} buttonColor={buttonColor} />}
          <div
            key={index}
            onClick={() => handleDotClick(index)}
            className={`z-10 cursor-pointer rounded-full absolute top-2 left-2 ${index === currentIndex ? 'w-[12px] h-[12px] opacity-100 ' : 'w-[10px] h-[10px] opacity-80'}`}
            style={{ backgroundColor: buttonColor }}
          />
        </div>
      ))}
    </div>
  );
};
